import {useCallback, useState} from "react";
import {SearchParamsKey} from "@/app/utils/use_search_params";
import {ChatRequests} from "@/app/api/chat";
import {NearbyUsersModel, UserRequests} from "@/app/api/user";
import {useNavigate} from "react-router-dom";
import {route} from "@/app/routes/AppRoutes";
import {CookiesKey} from "@/app/utils/cookies";
import Cookies from "js-cookie";

interface ScreenState {
  hasError?: string;
  hasLoading: boolean;
}

const useDetailPlayerPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState<ScreenState>({
    hasError: undefined,
    hasLoading: false,
  });

  const updateState = useCallback((updates: Partial<ScreenState>) => {
    setState((prev) => ({...prev, ...updates}));
  }, []);

  const createChat = useCallback(async (userId: number) => {
    updateState({hasLoading: true});
    try {
      const user = await UserRequests.getCurrentUser();
      const chat = await ChatRequests.createChat([user.user?.id, userId]);
      navigate(route.chats + "?" + (SearchParamsKey.chat + "=" + chat.id));
    } catch (e) {
      console.log(e)
    }
    updateState({hasLoading: false});
  }, []);

  const goToCreateAMatch = useCallback((user: NearbyUsersModel) => {
    const users = [user];
    Cookies.set(CookiesKey.users, JSON.stringify(users));
    navigate(route.createAMatch);
  }, [navigate]);

  return {
    state,
    createChat,
    goToCreateAMatch
  };
};

export default useDetailPlayerPage;